<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>
      <qr-edit-gateway
        v-model="showGatewayPopup"
        :sections="specialInfoSingle"
        :form-data="data"
        @edit-all="handleEditAll"
        @save="qrUpdate(true)"
        @cancel="onCancel"
      >
        <template v-slot:preview style="position: relative; min-height: 100%;">
          <div class="sticky-preview">
            <bale-mobile-preview
              v-model="data"
              :orders.sync="data.orders"
              :qr-svg-data-url="qrSvgDataUrl"

            />
          </div>
        </template>
      </qr-edit-gateway>
      <v-row class="mx-auto pa-2" no-gutters v-if="!showGatewayPopup">
        <!-- ستون پیش‌نمایش زنده موبایل بله -->
        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 100px; height: fit-content"
        >
          <bale-mobile-preview
            v-model="data"
            :orders.sync="data.orders"
            :qr-svg-data-url="qrSvgDataUrl"

          />
        </v-col>

        <!-- ستون فرم و استپر ویرایش -->
        <v-col cols="12" md="8">
          <v-card :disabled="loading" flat>
            <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
              <!-- مرحله اول: عنوان و آدرس کیوآر -->
              <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                <div class="row justify-center">
                  <div class="col-md-12">
                    <p class="font-weight-bold">ویرایش اطلاعات پیام‌رسان بله</p>
                  </div>

                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <v-text-field
                        v-model="data.visitName"
                        append-icon="mdi-pen"
                        class="mt-0 pt-0 contentinfo"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        dense
                        label="نام / عنوان کیوآر بله"
                        placeholder="مثال: کانال رسمی بله"
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-res-title`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="نام کیوآر"
                      />
                    </div>
                  </div>

                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <qr-address-field
                        id="qr-address"
                        v-model="res.identifier"
                        :domain-id="res.domain_id"
                        :error-messages="errors['identifier']"
                        append-icon="mdi-web"
                        class="mt-0 pt-0 contentinfo"
                        dense
                        :key="$t('qrAddressUpdate.hints.allowedChars')"
                        :hint="$t('qrAddressUpdate.hints.allowedChars')"
                        outlined
                        persistent-hint
                        readonly
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-res-identifier`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="آدرس کیوآر"
                      />
                    </div>
                  </div>
                </div>
              </v-stepper-step>

              <!-- بخش لیست آکاردئون تنظیمات اختصاصی بله -->
              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
                <div class="mb-4">
                  <!-- سوییچ و آیکون راهنما -->
                  <div class="d-flex align-center">
                    <v-switch
                      v-model="AutoSave"
                      color="primary"
                      class="mt-0 pt-0 shrink"
                      hide-details
                      label="ذخیره خودکار"
                    ></v-switch>

                    <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                    <v-tooltip bottom max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          x-small
                          class="mr-1"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop
                        >
                          <v-icon small color="grey darken-1">
                            mdi-help-circle-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                      </span>
                    </v-tooltip>
                  </div>

                  <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                  <div
                    v-if="$vuetify.breakpoint.xsOnly"
                    class="text-caption grey--text text--darken-1 mt-1 pr-1"
                    style="line-height: 1.4"
                  >
                    تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                  </div>
                </div>


                <list-expansion
                  v-model="data"
                  :components="specialInfo"
                  :data="data"
                  :service-name="serviceName"
                  :component-name="componentName"
                  flat
                  @save-required="AutoSave && qrUpdate(false)"
                />

                <div class="col-md-12 mt-4">
                  <next-btn
                    :loading="loading"
                    style="background: #00aa55"
                    @click="qrUpdate(true)"
                  />
                </div>
              </v-stepper-content>
            </v-stepper>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import BaleMobilePreview from "./component/baleMobilePreview.vue";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import PrevBtn from "@/view/content/fragments/prevBtn";
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrEditGateway from "../../qrland/components/QrEditGateway.vue";
import { mapActions } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "EditBale",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    BaleMobilePreview,
    QrAddressField,
    ListExpansion,
    NextBtn,
    PrevBtn,
    QrEditGateway,
    AtomSpinner
  },
  data() {
    return {
      isAutoSaving: false, 
      AutoSave:false,
      qrSvgDataUrl:"",
      showGatewayPopup: this.$route?.query?.gateway === "true",
      helpData: [],
      serviceName: "Qrland",
      componentName: "editBale",
      e6: 1,
      loading: false,
      errors: {},
      res: {},
      data: {
        visitName: "پیام‌رسان بله",
        orders: [
          { name: "baleBaseInfo" },
          { name: "photo" },
          { name: "baleActions" },
          { name: "pallete" },
        ],
        baleId: "",
        organizationName: "کانال رسمی بله",
        subtitle: "",
        aboutUs: "",
        appButtonText: "ورود به اپلیکیشن بله",
        webButtonText: "مشاهده در نسخه وب بله",
        desktopAction: "landing",
        pallete: {
          headColor: "linear-gradient(135deg, #0b4f3b, #169688)",
          bodyColor: "linear-gradient(180deg, #063024, #031a13)",
          textColor: "#ffffff",
          borderColor: "#169688",
        },
        photo: {
          profile: "",
          headBackground: "",
          transition: "scale",
          hasWelcome: false,
          showWelcome: false,
          hasGif: false,
          hasGame: false,
          previewerQr: {
            previewer: {
              gif: "",
              game: {},
              transition: "scale",
            },
          },
        },
      },
    };
  },

  computed: {
    // لیست آیتم‌های آکاردئون جهت ویرایش در صفحه
    specialInfo() {
      return [
        {
          name: "baleBaseInfo",
          value: "",
          title: "اطلاعات کانال / کاربری بله",
          icon: "chat-processing",
        },
        {
          name: "imageUploader",
          value: "",
          title: "لوگو/ تصویر هدر",
          icon: "camera-plus",
          model: "photo",
        },
        {
          name: "baleActions",
          value: "",
          title: "تنظیمات دکمه‌ها و ریدایرکت",
          icon: "cellphone-link",
        },
        {
          name: "colorPallete",
          value: "",
          title: "انتخاب رنگ",
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
        },
      ];
    },
    specialInfoSingle() {
      return [
        {
          name: "baleBaseInfo",
          value: "",
          title: "اطلاعات کانال / کاربری بله",
          icon: "chat-processing",
          description: "تنظیم نام، آیدی (@id)، عنوان و توضیحات بیو کانال بله",
        },
        {
          name: "imageUploader",
          value: "",
          title: "لوگو/ تصویر هدر",
          icon: "camera-plus",
          model: "photo",
          description: "تغییر و آپلود لوگوی کانال و تصویر پس‌زمینه کارت",
        },
        {
          name: "baleActions",
          value: "",
          title: "تنظیمات دکمه‌ها و ریدایرکت",
          icon: "cellphone-link",
          description: "سفارشی‌سازی متن دکمه‌های ورود به اپلیکیشن و وب بله",
        },
        {
          name: "colorPallete",
          value: "",
          title: "انتخاب رنگ",
          icon: "format-color-fill",
          model: "pallete",
          description: "شخصی‌سازی تم رنگی، گرادیانت هدر و رنگ متون",
        },
      ];
    },

    domainName() {
      return this.$route.params?.name?.replace("?gateway=true", "");
    },

    qrId() {
      return this.$route.params?.id?.replace("?gateway=true", "");
    },
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),

    onCancel() {
      this.goto("qr/list");
    },

    handleEditAll() {
      this.showGatewayPopup = false;
    },

    fetchData() {
      this.loading = true;
      this.$api
        .get(
          `/v1/testQr/find/${this.domainName}${
            this.qrId ? "/" + this.qrId : ""
          }`
        )
        .then(({ data }) => {
          this.setCreatedQrID(data.data.id);
          this.qrSvgDataUrl= data?.data?.img_url||''; 
          let info = data.data.data.data || data.data.data || {};

          // حفظ و تطبیق ساختار photo و pallete
          if (!info.photo) {
            info.photo = { profile: "", headBackground: "" };
          }
          if (!info.pallete) {
            info.pallete = {
              headColor: "linear-gradient(135deg, #0b4f3b, #169688)",
              bodyColor: "linear-gradient(180deg, #063024, #031a13)",
              textColor: "#ffffff",
              borderColor: "#169688",
            };
          }

          if (!info.orders || info.orders.length === 0) {
            this.$set(info, "orders", [
              { name: "baleBaseInfo" },
              { name: "photo" },
              { name: "baleActions" },
              { name: "pallete" },
            ]);
          }

          this.data = { ...this.data, ...info };
          this.res = data.data;
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در دریافت اطلاعات کیوآر بله!");
          console.error("error in get bale data: ", response);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    qrUpdate(final = false) {
      if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const formData = new FormData();
      formData.append("type", "qrbale");
      formData.append("qrType", "dynamic");
      formData.append("domain", this.res.domain?.name || "");
      formData.append("identifier", this.res.identifier || "");
      formData.append("qr_id", this.res.qrId || "");
      formData.append("_method", "PUT");
      formData.append("title", this.data.visitName || "پیام‌رسان بله");

      formData.append(
        "data",
        JSON.stringify({
          theme: "",
          data: this.data,
        })
      );

      this.$api
        .post("/v1/testQr/update", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          if(final || !this.AutoSave)
          this.$toast.success("کیوآر پیام‌رسان بله با موفقیت ویرایش شد.");
          if (final) {
            this.goto("qr/list");
          }
        })
        .catch((err) => {
          console.error("error in update bale: ", err);
          this.$toast.error("خطا در به‌روزرسانی کیوآر بله");
        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;
        });
    },
  },
};
</script>

<style scoped>
.sticky-preview {
  position: sticky;
  top: 100px;
}
</style>
